import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Camera, CameraResultType } from '@capacitor/camera';
import { AttachmentStore } from '../Attachments/AttachmentStore';
import { DeliveryIndentifier } from '../Deliveries/DeliveriesStore';

export class CameraActivator { 
    private static _cameraActivator = new CameraActivator();

    public static get instance() { 
        return this._cameraActivator;
    }

    private constructor() { 
        defineCustomElements(window);
    }

    public async takePicture(deliveryIdentifier: DeliveryIndentifier) {
        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Base64 
        });

        // image.webPath will contain a path that can be set as an image src.
        // You can access the original file using image.path, which can be
        // passed to the Filesystem API to read the raw data of the image,
        // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
        var imageUrl = image.webPath;

        await AttachmentStore.instance.addAttachment(deliveryIdentifier, image.base64String, image.format);

        // Can be set to the src of an image now

    }
}